/** @jsx jsx */
import type { ReactNode } from 'react';
import { jsx, css } from '@compiled/react';
import { xcss, Grid } from '@atlaskit/primitives';
import UFOSegment from '@atlaskit/react-ufo/segment';
import {
	Tokens,
	NAV4_HORIZONTAL_NAV_HEIGHT,
	NAV4_HORIZONTAL_NAV_HEIGHT_NEW,
} from '@atlassian/jira-custom-theme-constants/src/constants.tsx';
import { useIsFullscreen } from '@atlassian/jira-layout-controller/src/controllers/layout-controller/consumers/fullscreen/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

type Props = {
	children: ReactNode;
};
const NavWrapper = ({ children }: Props) => {
	const [isFullscreen] = useIsFullscreen();
	return (
		<UFOSegment name="jira-horizontal-nav">
			<header
				id="ak-project-view-navigation"
				css={headerStyles}
				data-testid="horizontal-nav.ui.content.horizontal-nav"
			>
				<Grid
					gap="space.050"
					alignItems="end"
					xcss={[
						fg('blu-6305_tab_item_styling_in_horizontal_navigation')
							? contentStylesWithReducedPadding
							: contentStyles,
						!isFullscreen &&
							(fg('blu-6305_tab_item_styling_in_horizontal_navigation')
								? minHeightStyleReduced
								: minHeightStyle),
					]}
				>
					{children}
				</Grid>
			</header>
		</UFOSegment>
	);
};

export default NavWrapper;

const minHeightStyle = xcss({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
	minHeight: `${NAV4_HORIZONTAL_NAV_HEIGHT}px`,
});

const minHeightStyleReduced = xcss({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
	minHeight: `${NAV4_HORIZONTAL_NAV_HEIGHT_NEW}px`,
});

const contentStyles = xcss({
	paddingTop: 'space.300',
});

const contentStylesWithReducedPadding = xcss({
	paddingTop: 'space.150',
});

const headerStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	background: Tokens.ELEVATION_SURFACE_CONTRAST,
	boxSizing: 'border-box',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	backdropFilter: Tokens.BACKDROP_FILTER,
});
